<script setup>
import { ref, getCurrentInstance, onMounted, reactive } from "vue-demi";
import dayjs from "dayjs"
import { ElMessage,ElMessageBox } from 'element-plus'

const { appContext } = getCurrentInstance()

const qrcodeData = ref()
const loading = ref(true)

const queryTable = (data) => {
  loading.value = true
  appContext.config.globalProperties.$api.qrcode.queryList(data).then(r => {
    if (r.status == 200) {
      qrcodeData.value = r.data
      pagination.page = r.pagination.currentPage
      pagination.total = r.pagination.total
      pagination.perPage = r.pagination.perPage
    } else {
      ElMessage.error('查询失败')
    }
    loading.value = false
  })
}

const pagination = reactive({
  page: 1, // 当前页
  total: 0,  // 总条数
  perPage: 0  // 每页显示几条
})

const pageChange = (page) => {
  queryTable({ page: page })
}


/* 
* @describe 打开并生成二维码
*/
const isShow = ref(false)

const handleGenerateCode = () => {
  appContext.config.globalProperties.$api.qrcode.generate({ number: qrcodes.number }).then(r => {
    if (r.status == 200) {
      ElMessage({ message: '二维码生成成功', type: 'success', })
      isShow.value = false
      queryTable()
    } else {
      ElMessage.error('二维码生成失败')
    }
  })
}

const qrcodes = ref({ number: 0 })

onMounted(() => {
  queryTable()
})

const handleChange = (val) => {
  qrcodes.number = val
}

/* 
* @describe 导出
*/
const extendsData = ref([])
const handleExport = () => {
  appContext.config.globalProperties.$api.qrcode.export({ identifying_codes: extendsData.value.map(item=>item.identifying_code) }, "二维码")
}

const handleSelectionChange = (val) => {
  extendsData.value = val
}

// 解绑
const handleUnQrcode =()=>{
  let data= extendsData.value.map(item=>item.identifying_code)
  if(data.length!==0){
    ElMessageBox.alert("确定解绑该识别码","温馨提示",{
      confirmButtonText:"确定",
      callback:(action)=>{
        if(action=="confirm"){
          // unBundQrCode({device_ids:data})
          unBundQrCode({identify_code:data})
        }
      }
    })
  }else{
    ElMessage.error('识别码不能为空，请选择识别码')
  }
}

// 解绑设备
// function unBundQrCode(data){
//   appContext.config.globalProperties.$api.qrcode.unbund(data).then(r=>{
//     if (r.status==200) {
//       ElMessage({ message: '二维码解绑成功', type: 'success', })
//       queryTable()
//     }else{
//       ElMessage.error('解绑失败')
//     }
//   })
// }

// 解绑二维码
function unBundQrCode(data){
  appContext.config.globalProperties.$api.qrcode.unbundcode(data).then(r=>{
    if (r.status==200) {
      ElMessage({ message: '二维码解绑成功', type: 'success', })
      queryTable()
    }else{
      ElMessage.error('解绑失败')
    }
  })
}

</script>

<template>
  <div class="container">
    <div class="control">
      <el-button type="danger" @click="handleUnQrcode()">解绑二维码</el-button>
      <el-button type="warning" @click="handleExport()">导出二维码</el-button>
      <el-button type="primary" @click="isShow=!isShow">生成二维码</el-button>
    </div>
    <el-table :data="qrcodeData" style="width: 100%" v-loading="loading" size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="identifying_code" label="二维码识别码">
        <template #default="scope">
          <span>https://api.yuyooke.com/api/pay/polymerization_pay?identifying_code={{scope.row.identifying_code}}</span>
        </template>
      </el-table-column>>
      <el-table-column prop="agent_name" label="代理商名称" width="120" />
      <el-table-column prop="salesman_name" label="业务员名称"  width="120" />
      <el-table-column prop="merchant_name" label="商店名称"  width="120" />
      <el-table-column prop="store_name" label="门店名称"  width="120" />
      <el-table-column prop="device_number" label="设备序列号"  width="180" />
      <el-table-column prop="created_at" label="创建时间"  width="180">
        <template #default="scope">
          <span>{{dayjs(scope.row.created_at).format("YYYY-MM-DD")}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background :page-size=15 layout="total, prev, pager, next" :total=pagination.total @current-change="pageChange" :current-page=pagination.page />
    </div>
    <el-dialog v-model="isShow" title="生成二维码">
      <el-form :model="qrcodes" label-width="120px">
        <el-form-item label="生成数量：" :inline="true">
          <el-input-number v-model="qrcodes.number" :min="0" :max="1000" controls-position="right" @change="handleChange" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleGenerateCode()">生成二维码</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
.container {
  .control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 10px 0;
  }
  .pagination {
    margin: 1.25rem 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
